<template>
  <div class="home">
    <div class="body">
      <div class="gridz">
        <div class="card card-blue">
          <div>
            <h1>Rp {{ summary.hariIni.total_penjualan | number}}</h1>
            <p>Penjualan hari ini</p>
          </div>
        </div>
        <div class="card card-red">
          <div>
            <h1>Rp {{ summary.kemarin.total_penjualan | number }}</h1>
            <p>Penjualan kemarin </p>
          </div>
        </div>
        <div class="card card-green">
          <div>
            <h1>{{ summary.hariIni.item_terjual | number }}&nbsp;</h1>
            <p>Item terjual</p>
          </div>
        </div>
        <div class="card card-yellow">
          <div>
            <h1>{{ summary.hariIni.jumlah_nota | number }}&nbsp;</h1>
            <p>Total transaksi</p>
          </div>
        </div>
      </div>

      <div class="second-row">
        <div class="menu-favorit">
          <h3>Menu favorit</h3>
          <div class="table-wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Menu</th>
                  <th>Jumlah</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dataMenuFavorit" :key="index">
                  <td>{{ ++index }}</td>
                  <td>{{ item.menu }}</td>
                  <td>{{ item.total }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="traffic-pelanggan">
          <div class="header">
            <h3>Traffic pelanggan</h3>
            <select v-model="filter.day" @change="loadTrafficPelanggan()">
              <option value="mon">Senin</option>
              <option value="tue">Selasa</option>
              <option value="wed">Rabu</option>
              <option value="thu">Kamis</option>
              <option value="fri">Jumat</option>
              <option value="sat">Sabtu</option>
              <option value="sun">Minggu</option>
            </select>
          </div>
          <div class="table-wrapper">
            <table class="table">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Jam</th>
                  <th>Keramaian</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item, index in dataKeramaian" :key="index">
                  <td>{{ ++index }}</td>
                  <td>{{ item.jam.toString().padStart(2,'0') + ':00'}}</td>
                  <td>{{ item.total}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="grafik">
        <h3>Penjualan harian</h3>

        <table>
          <tr>
            <td>Tgl</td>
            <td>
              {{ moment(selectedGrafik.tanggal).format("DD MMM YYYY") }}
            </td>
          </tr>
          <tr>
            <td>Penjualan</td>
            <td>Rp {{ selectedGrafik.grand_total | number }}</td>
          </tr>
          <tr>
            <td>Jumlah nota</td>
            <td>{{ selectedGrafik.jumlah_nota | number }}</td>
          </tr>
        </table>

        <div class="loading" v-show="loadingGrafikHarian">
          <p>Loading...</p>
        </div>

        <div class="graph">
          <div
            v-for="(item, index) in laporanGrafik"
            :key="index"
            @mouseover="selectedGrafik = item"
            @click="$router.push('/laporan/penjualan?tgl_awal=' + item.tanggal + '&tgl_akhir=' + item.tanggal)"
          >
            <div class="graph-box" :style="'height:' + item.persen + 'px'">
              <span class="top"> {{ item.grand_total | number }}</span>
              <span> {{ moment(item.tanggal).format("DD/MM") }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="grafik">
        <h3>Penjualan bulanan</h3>

        <table>
          <tr>
            <td>Bulan</td>
            <td>
              {{ namaBulan[selectedGrafikBulanan.bulan] }}
            </td>
          </tr>
          <tr>
            <td>Penjualan</td>
            <td>Rp {{ selectedGrafikBulanan.grand_total | number }}</td>
          </tr>
          <tr>
            <td>Jumlah nota</td>
            <td>{{ selectedGrafikBulanan.jumlah_nota | number }}</td>
          </tr>
        </table>

        <div class="loading" v-show="loadingGrafikBulanan">
          <p>Loading...</p>
        </div>

        <div class="graph bulanan">
          <div
            v-for="(item, index) in laporanGrafikBulanan"
            :key="index"
            @mouseover="selectedGrafikBulanan = item"
            @click="$router.push('/laporan/penjualan?tgl_awal=' + moment().format('YYYY-'+item.bulan+'-01') + '&tgl_akhir=' + moment().format('YYYY-'+item.bulan+'-DD'))"
          >
            <div class="graph-box" :style="'height:' + item.persen + 'px'">
              <span class="top"> {{ item.grand_total | number }}</span>
              <span> {{ namaBulan[item.bulan] }}</span>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import * as api from "./../api/Api";

import Logo from "./icons/Logo.vue";

export default {
  name: "Home",
  components: {
    Logo,
  },
  data() {
    return {
      sticky: false,
      filter: {
        id_toko: this.$toko.id,
        tgl_awal: moment().format("YYYY-MM-01"),
        tgl_akhir: moment().format("YYYY-MM-DD"),
        day: moment().format("ddd").toLowerCase(),
      },
      dataMenuFavorit: [],
      dataKeramaian: [],
      laporanGrafik: [],
      selectedGrafik: {},
      laporanGrafikBulanan: [],
      selectedGrafikBulanan: {},
      summary: {
        hariIni: {},
        kemarin: {},
      },
      namaBulan: [
        "",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ags",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ],

      loadingGrafikHarian: false,
      loadingGrafikBulanan: false,
    };
  },
  methods: {
    moment,
    detail(id) {
      this.$router.push("/detail/" + id);
    },
    loadSummary() {
      api
        .get(
          "/v4/laporan/penjualan?id_toko=" +
            this.$toko.id +
            "&tgl_awal=" +
            moment().format("YYYY-MM-DD") +
            "&tgl_akhir=" +
            moment().format("YYYY-MM-DD")
        )
        .then((r) => {
          this.summary.hariIni = r.summary;
        });

      api
        .get(
          "/v4/laporan/penjualan?id_toko=" +
            this.$toko.id +
            "&tgl_awal=" +
            moment().subtract(1, "days").format("YYYY-MM-DD") +
            "&tgl_akhir=" +
            moment().subtract(1, "days").format("YYYY-MM-DD")
        )
        .then((r) => {
          this.summary.kemarin = r.summary;
        });
    },
    loadMenuFavorit() {
      api
        .get(
          "/v4/laporan/penjualan/menu-favorit?tipe=menu_favorit&" +
            this.$objectToQuery(this.filter)
        )
        .then((r) => {
          this.loading = false;
          this.dataMenuFavorit = r.data;
        })
        .catch((e) => {
          this.loading = false;
          this.openFilter = false;
        });
    },
    loadTrafficPelanggan() {
      api
        .get(
          "/v4/laporan/penjualan/keramaian?id_toko=" +
            this.$toko.id +
            "&day=" +
            this.filter.day
        )
        .then((r) => {
          this.dataKeramaian = r.data;
        })
        .catch((e) => {
          this.loadingMenu = false;
        });
    },
    loadGrafikHarian() {
      this.loadingGrafikHarian = true;

      api
        .get(
          "/v4/laporan/penjualan/grafik?" +
            this.$objectToQuery(this.filter) +
            "&count=14"
        )
        .then((r) => {
          this.loadingGrafikHarian = false;

          if (r.valid) {
            this.laporanGrafik = r.data;
            this.laporanGrafik.forEach((item) => {
              item.persen = (300 / 100) * item.persen;
            });

            this.selectedGrafik =
              this.laporanGrafik[this.laporanGrafik.length - 1];
          }
        })
        .catch((e) => {
          this.loadingGrafikHarian = false;
        });
    },
    loadGrafikBulanan() {
      this.loadingGrafikBulanan = true;
      api
        .get(
          "/v4/laporan/penjualan/grafik-bulanan?" +
            this.$objectToQuery(this.filter)
        )
        .then((r) => {
          this.loadingGrafikBulanan = false;

          if (r.valid) {
            this.laporanGrafikBulanan = r.data;
            this.laporanGrafikBulanan.forEach((item) => {
              item.persen = (300 / 100) * item.persen;
            });

            this.selectedGrafikBulanan =
              this.laporanGrafikBulanan[this.laporanGrafikBulanan.length - 1];
          }
        })
        .catch((e) => {
          this.loadingGrafikBulanan = false;
        });
    },
  },
  mounted() {
    this.loadMenuFavorit();
    this.loadSummary();
    this.loadTrafficPelanggan();
    this.loadGrafikHarian();
    this.loadGrafikBulanan();

    var lastScrollTop = 0;
    const self = this;

    // element should be replaced with the actual target element on which you have applied scroll, use window in case of no target element.
    document.addEventListener(
      "scroll",
      function () {
        // or window.addEventListener("scroll"....
        var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (st > lastScrollTop) {
          // downscroll code
          if (st > 150) {
            // self.sticky = true
          }
        } else {
          // upscroll code
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      },
      false
    );
  },
};
</script>

<style scoped lang="scss">
.body {
  .gridz {
    background: var(--light-blue);
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 30px;
    padding: 40px;
    border-radius: 10px 10px 0 0;

    .card {
      border-radius: 6px !important;
      padding: 15px;
      background: #fff;
      box-shadow: 3px 3px 3px #ccc !important;
      cursor: pointer;
      h1 {
        margin: 0;
        font-size: 26px;
        font-weight: normal;
      }
      p {
        font-size: 14px;
        margin-bottom: 0;
      }
      &.card-blue {
        border-bottom: 5px solid var(--primary);
      }
      &.card-red {
        border-bottom: 5px solid #ff5a5b;
      }

      &.card-green {
        border-bottom: 5px solid #0fc469;
      }

      &.card-yellow {
        border-bottom: 5px solid #f9c851;
      }
    }
  }

  .second-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 30px;
    padding: 20px 40px;

    .menu-favorit,
    .traffic-pelanggan {
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        select {
          width: 150px;
        }
      }
      .table-wrapper {
        height: 300px;
      }
    }
  }

  .grafik {
    padding: 20px 40px;
    position: relative;
    &:last-child {
      margin-bottom: 30px;
    }

    .loading {
      position: absolute;
      width: 100%;
      p {
        text-align: center;
        padding-top: 100px;
      }
    }

    table {
      position: absolute;
      background-color: var(--light-blue);
      padding: 10px;
      border-radius: 10px;
      box-shadow: 3px 3px 3px #ccc;
      z-index: 2;

      tr {
        td {
          font-size: 14px;
        }
      }
    }
  }

  .graph {
    display: grid;
    grid-template-columns: repeat(15, 1fr);
    grid-column-gap: 15px;
    align-items: end;
    height: 300px;
    margin-top: 80px;
    &.bulanan {
      grid-template-columns: repeat(12, 1fr);
    }

    &.traffic {
      display: flex;
      justify-content: space-around;

      .graph-box {
        position: relative;
      }

      small {
        position: absolute;
        top: -15px;
        color: #333;
      }
    }

    > div {
      height: 300px;
      display: flex;
      align-items: flex-end;
      &:hover {
        background-color: #eee;
        opacity: 0.6;
        cursor: pointer;
      }
    }

    .graph-box {
      background: var(--primary);
      background-image: linear-gradient(0deg, var(--primary) 0%, #81caff 100%);
      width: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      color: #fff;
      font-size: 13px;
      position: relative;

      span {
        font-size: 13px;
        margin-bottom: -18px;
        color: #333;
        &.top {
          position: absolute;
          top: 0;
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue